import React, { useEffect, useRef, useState } from 'react'

const PLACEHOLDER_LEVEL = 6

// Thumbnails are deep-zoom tiles: .../<level>/0_0.webp. A low level is a tiny
// copy of the same image, used as a blurred placeholder while the full one loads.
const getPlaceholderUrl = url => {
  const placeholder = (url || '').replace(
    /\/\d+\/(\d+_\d+\.\w+)$/,
    `/${PLACEHOLDER_LEVEL}/$1`
  )
  return placeholder !== url ? placeholder : null
}

const fill = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%'
}

const ProgressiveThumbnail = ({ src, objectFit = 'cover', style }) => {
  const [loadedSrc, setLoadedSrc] = useState(null)
  const imgRef = useRef(null)
  const placeholder = getPlaceholderUrl(src)
  const loaded = loadedSrc === src

  // covers images that finished loading from cache before onLoad was attached
  useEffect(() => {
    const img = imgRef.current
    if (img && img.complete && img.naturalWidth) setLoadedSrc(src)
  }, [src])

  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        aspectRatio: '1.414/1',
        ...style
      }}
    >
      {placeholder && (
        <img
          src={placeholder}
          alt=""
          aria-hidden="true"
          style={{
            ...fill,
            objectFit,
            filter: 'blur(8px)',
            transform: 'scale(1.1)'
          }}
        />
      )}
      <img
        ref={imgRef}
        src={src}
        alt=""
        onLoad={() => setLoadedSrc(src)}
        style={{
          ...fill,
          objectFit,
          opacity: loaded || !placeholder ? 1 : 0,
          transition: 'opacity 0.3s ease-in'
        }}
      />
    </div>
  )
}

export default ProgressiveThumbnail
